module.exports = __webpack_public_path__ + "img/resultado2.3d3d4f9c.jpg";